import { FC, ReactNode, createContext, useContext } from 'react';

// Create context for debug state
export const DebugContext = createContext({
  showDebug: false,
  toggleDebug: () => {},
  compareScores: () => {},
  isComparing: false
});

// Custom hook to access the debug context
export const useDebug = () => useContext(DebugContext);

interface DebugSectionProps {
  children: ReactNode;
  label: string;
  className?: string;
}

// Individual debug section component
export const DebugSection: FC<DebugSectionProps> = ({ children, label, className = '' }) => {
  const { showDebug } = useContext(DebugContext);

  return (
    <div className={`relative ${showDebug ? 'debug-cell' : ''} ${className}`}>
      {showDebug && <div className="debug-label">{label}</div>}
      {children}
    </div>
  );
};

// Main debug layout component
interface DebugLayoutProps {
  children: ReactNode;
}

export const DebugLayout: FC<DebugLayoutProps> = ({ children }) => {
  // Now we just use the context values instead of maintaining local state
  const { showDebug } = useContext(DebugContext);

  return (
    <div className={`relative ${showDebug ? 'debug-layout' : ''}`}>
      {children}
    </div>
  );
};
